<template>
  <div>
    <div class="mt-3 text-center">
      <h1>Forbidden</h1>
      <p>You need to be an administrator to view this page</p>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'Forbidden',
  }
</script>

<style scoped>

</style>
